import React, { useMemo } from 'react';

export function decodeRichHtml(value) {
  if (!value || typeof value !== 'string') return '';
  if (typeof document === 'undefined') return value;

  let decoded = value;
  for (let i = 0; i < 2; i += 1) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = decoded;
    const next = textarea.value;
    if (next === decoded) break;
    decoded = next;
  }
  return decoded;
}

export function richTextSummary(value, maxLength = 220) {
  const html = decodeRichHtml(value);
  const container = typeof document !== 'undefined' ? document.createElement('div') : null;
  if (container) {
    container.innerHTML = html;
    const text = (container.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > maxLength ? `${text.slice(0, maxLength).trim()}...` : text;
  }
  const text = html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  return text.length > maxLength ? `${text.slice(0, maxLength).trim()}...` : text;
}

export function normalizeRichHtml(value) {
  const decoded = decodeRichHtml(value);
  if (!decoded || typeof document === 'undefined') return decoded;

  const container = document.createElement('div');
  container.innerHTML = decoded;

  container.querySelectorAll('table').forEach(table => {
    if (table.parentElement?.classList.contains('public-rich-table-wrap')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'public-rich-table-wrap';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });

  return container.innerHTML;
}

export default function RichContent({ html, className = '' }) {
  const normalizedHtml = useMemo(() => normalizeRichHtml(html), [html]);
  return <div className={`public-rich-content ${className}`.trim()} dangerouslySetInnerHTML={{ __html: normalizedHtml }} />;
}
